import React, { useState } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import {
    GlobalNavLinkContentProps,
    useCurrentNav
} from "./nav-links-container";

export type GlobalNavLinkProps = GlobalNavLinkContentProps;

const GlobalNavLink = (props: GlobalNavLinkProps) => {
    const { current, setCurrent } = useCurrentNav();

    const isCurrentOpenDropdown = current === props.globalLinksKey;

    const [isOpen, setIsOpen] = useState(false);

    const anchorLinkClassName = `nav-link-anchor 
    ${!!isCurrentOpenDropdown && !!props.hasSubnav ? "isActive" : ""} 
    ${!props.hasSubnav ? "isHoverableLink" : ""} 
    ${props.isActive ? "isActive" : ""}`;

    const linkClickAction: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        if (props.hasSubnav) {
            e.preventDefault();
            if (isOpen) {
                setCurrent("");
                setIsOpen(false);
            } else {
                setCurrent(props.globalLinksKey);
                setIsOpen(true);
            }
        }
    };

    return (
        <>
            <a
                className={anchorLinkClassName}
                css={css({
                    "display": "flex",
                    "alignItems": "center",
                    "textDecoration": "none",
                    "lineHeight": "1rem",
                    "marginBlockEnd": "-1px",
                    "&.isActive": {
                        color: "#0052cc"
                    },
                    "&.isHoverableLink:hover": {
                        color: "#0052cc"
                    },
                    [media.above.md]: {
                        borderRadius: "3px",
                        textDecoration: "none"
                    }
                })}
                href={props.href ?? "#"}
                onClick={linkClickAction}
                onMouseEnter={() => {
                    if (!isCurrentOpenDropdown) {
                        setCurrent(props.globalLinksKey);
                        setIsOpen(true);
                    }
                }}
                aria-label={props.linkText}
                data-event="clicked"
                data-event-component="linkButton"
                data-event-container="headerDropdownLink"
                data-product-key={props.productKey ?? "jiraSoftware"}
            >
                {props.linkText}
                {!!props.hasSubnav && (
                    <div
                        className="chevron-icon"
                        css={css({
                            display: "block",
                            color: "#0052cc",
                            marginInlineStart: "8px",
                            lineHeight: 0
                        })}
                    >
                        {isCurrentOpenDropdown ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="6"
                                viewBox="0 0 11 6"
                                fill="none"
                            >
                                <path
                                    d="M1.19922 4.81824L5.19922 1.18187L9.19922 4.81824"
                                    stroke="#1868DB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="6"
                                viewBox="0 0 11 6"
                                fill="none"
                            >
                                <path
                                    d="M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176"
                                    stroke="#101214"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        )}
                    </div>
                )}
            </a>
        </>
    );
};

export default GlobalNavLink;
